<!--转单产品-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="材料名称">
            <a-input v-decorator="['name']" placeholder="请输入"></a-input>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
          <a-button class="app-btn" type="primary" @click="handleAdd">添加材料</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">客户库材料列表</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="
            (record, index) => {
              return index
            }
          "
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :scroll="{ x: 1400 }"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: limit,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>

    <a-modal
      v-model="modal.visible"
      :width="1000"
      :title="modal.title"
      okText="确认"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <div>
        <a-form :form="modal.form" layout="inline">
          <a-form-item label="材料名称">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '材料名称不能为空', trigger: 'blur' }],
                },
              ]"
              placeholder="请输入"
            ></a-input>
          </a-form-item>
          <a-form-item label="资料要求" :wrapperCol="{ style: 'width: 100%' }">
            <RichText
              v-decorator="['description', { rules: [{ required: false, message: '请输入资料要求' }] }]"
            ></RichText>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import RichText from '@/components/RichText'
export default {
  components: {
    Page,
    RichText
  },
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.limit * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '材料名称',
        align: 'center',
        dataIndex: 'name',
      },
      {
        title: '关联材料个数',
        align: 'center',
        dataIndex: 'fileNum',
      },
      {
        title: '最后操作人',
        align: 'center',
        dataIndex: 'operator',
      },
      {
        title: '最后操作时间',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.handleEdit(row)
                }}
              >
                编辑
              </a>
              <a
                onClick={() => {
                  this.handleDel(row)
                }}
              >
                删除
              </a>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      limit: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],

      modal: {
        form: this.$form.createForm(this),
        visible: false,
        title: '',
        record: {},
      },
    }
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
      }
    },
    async doQuery(_page = this.pageNumber, _limit = this.limit) {
      this.tableLoading = true
      const res = await this.$axios.get('/user/admin/customer/dictionary/getList', {
        params: {
          page: _page,
          limit: _limit,
          ...this.getParams(),
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    handleAdd() {
      this.modal.title = '添加'
      this.modal.visible = true
    },
    handleEdit(row) {
      this.modal.title = '编辑'
      this.modal.record = row
      this.modal.visible = true
      this.$nextTick(() => {
        this.modal.form.setFieldsValue({
          name: row.name,
          description: row.description,
        })
      })
    },
    async handleDel(row) {
      const res = await this.$axios.delete('/user/admin/customer/dictionary/delete', {
        params: {
          id: row.id,
        },
      })
      if (res.success) {
        this.$message.success('删除成功')
        this.doQuery()
      }
    },
    handleCancel() {
      this.modal.visible = false
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          let params = {}
          let url = ''
          if (this.modal.title == '添加') {
            url = '/user/admin/customer/dictionary/save'
            params = { name: values.name, description: values.description }
            const res = await this.$axios.post(url, {
              ...params,
            })
            if (res.success) {
              this.$message.success('添加成功')
              this.handleCancel()
              this.doQuery()
            }
          } else {
            url = '/user/admin/customer/dictionary/edit'
            params = {
              id: this.modal.record.id,
              name: values.name,
              description: values.description,
            }
            const res = await this.$axios.put(url, {
              ...params,
            })
            if (res.success) {
              this.$message.success('编辑成功')
              this.handleCancel()
              this.doQuery()
            }
          }
        }
      })
    },
  },
}
</script>

<style lang="less"></style>
